// src/components/DigitalCardPrint.js

import React, { forwardRef } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import brandLogoWhite from '../assets/logo/logo-white.png';
import moment from 'moment';

const DigitalCardPrint = forwardRef(({ passData }, ref) => {
  if (!passData) return null;

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return moment(dateString).format('DD/MM/YYYY');
  };

  return (
    <div ref={ref} className="print-card-container front">
      <div className="card-header">
        <h1>Grams Subscription Card</h1>
        <div className="qr-code-wrapper">
          <QRCodeSVG
            value={window.location.origin + `/membership/view?data=${btoa(JSON.stringify({ id: passData.id }))}`}
            size={80}
            bgColor="#FFFFFF"
            fgColor="#383837"
            />
        </div>
      </div>
      
    
      
      <div className="card-body">
        <h2>{passData.plan}</h2>
        <p>Start Date: {formatDate(passData.start)}</p>
        <p>Expires on: {formatDate(passData.expiry)}</p>
      </div>
      
      
      
      <div className="card-footer">
        <p className="member-name">{passData.name}</p>
        <img src={brandLogoWhite} alt="Grams Logo" className="card-logo-icon" />
      </div>
    </div>
  );
});

export default DigitalCardPrint;